import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../store/loaderSlice";
import EMPTY_BASKET_IMAGE from "../img/empty_cart_once.gif";
import { footerActions } from "../store/footerSlice";
import appConst from "../Utilities/appConst.json";
import { LanguageContext } from "../context/language/LanguageContext";
import CustomButton from "../shared/CustomButton";
import useBrazeScreenView from "../hooks/useBrazeScreenView";

const EmptyBasketPage = () => {
  useBrazeScreenView();
  const languageContext = useContext(LanguageContext);
  const isBasketEmpty = useSelector((state) => state.error.isBasketEmpty);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isBasketEmpty) {
      dispatch(loaderActions.loaderHide());
    }
  }, [isBasketEmpty]);

  useEffect(() => {
    dispatch(footerActions.setIsShow(false));
  }, []);

  const beforeContinue = () => {
    if (typeof window.LupaNative !== "undefined") {
      window.LupaNative.exit();
    }
  };

  return (
    <div className="container empty_basket_page">
      <div className="error_page_txt" style={{ marginBottom: "-60px" }}>
        <h3>
          {languageContext.getTranslation(appConst.EMPTY_BASKET_PAGE_TITLE)}
        </h3>
        <p>
          {languageContext.getTranslation(appConst.EMPTY_BASKET_PAGE_CONTENT)}
        </p>
      </div>
      <img
        className="empty_basket_page_img"
        src={EMPTY_BASKET_IMAGE}
      />
      <div className="next_btn" style={{ padding: 0 }}>
        <CustomButton
          nextPage={appConst.LUPA_SITE}
          background={appConst.LUPA_GREEN_COLOR}
          color={appConst.LUPA_ENABLE_FONT_COLOR}
          variant="contained"
          btnText={languageContext.getTranslation(appConst.LETS_START)}
          beforeContinue={beforeContinue}
          redirect={true}
          data-testid="empty-basket-next-button"
        ></CustomButton>
      </div>
    </div>
  );
};

export default EmptyBasketPage;
